//react
import { useEffect, useState } from 'react';

//service
import { getAllAreaStat } from '../../../service/monitor/monitorDashboardService';

//component
import DataInfoArea from './dataInfoArea';
import MapInfo from './mapInfo';
import { BeatLoader } from 'react-spinners';

//css
import './monitorDashboard.css';
import { getDashboardList } from '../../../service/monitor/monitorDashboardService_test';
import { getUser, isAdmin } from '../../../service/authService';
import { useHistory } from 'react-router';

const MonitorDashboard = ({ conn, dongList }) => {
  const history = useHistory();
  const userInfo = getUser();
  const [loading, setLoading] = useState(false);
  const [allAreaStat, setAllAreaStat] = useState([]);
  const [chngState, setChngState] = useState(true);
  const [today, setToday] = useState('');

  /* 조회 service */
  const getAllAreaStatFunc = response => {
    response.forEach(item => {
      item.isOver = false;
      item.isClicked = false;
    });
    //담당자일때
    if (userInfo.userTypeCode === 2002) {
      response.forEach(item => {
        if (item.dongCode === userInfo.dongCode) item.isClicked = true;
      });
    }
    setAllAreaStat(response);
  };
  const getRejection = (name, error) => {
    console.log(name, error);
    return;
  };

  const getAllDataList = () => {
    // setAllAreaStat(getDashboardList());
    setLoading(true);
    Promise.all([getAllAreaStat(conn, getAllAreaStatFunc, getRejection)])
      .then(() => {
        setLoading(false);
      })
      .catch(error => {
        console.log('moniotorDashBoardService Error', error);
      });
  };

  //15분마다 데이터 새로고침
  const resetData = () => {
    setTimeout(() => {
      setToday(new Date());
    }, 90000);
  };

  useEffect(() => {
    if (!isAdmin()) {
      alert('권한이 없습니다.');
      history.push('/');
    }
    resetData();
    getAllDataList();
  }, [today]);

  return (
    <div
      className="monitorDashBoardContents"
      style={
        loading
          ? {
              opacity: 0.6,
              pointerEvents: 'none',
            }
          : null
      }>
      <MapInfo conn={conn} dataSource={allAreaStat} setDataSource={setAllAreaStat} chngState={chngState} setChngState={setChngState} userInfo={userInfo} />
      <DataInfoArea conn={conn} dongList={dongList} dataSource={allAreaStat} chngState={chngState} />
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={24} color="#1e88e5" />
        </p>
      )}
    </div>
  );
};
export default MonitorDashboard;
